import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

export default defineNuxtPlugin(() => {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return {
    provide: {
      formatFilterToggle: (v) => v === 'true' || undefined,
      formatDate: (d, timeIncluded?: Boolean, utc?: Boolean) => {
        if (utc) {
          return d
            ? dayjs(d)
                .utc('z')
                .tz(dayjs.tz.guess())
                .format(`YYYY-MM-DD${timeIncluded === true ? ' HH:mm:ss' : ''}`)
            : null
        }

        return d
          ? dayjs(d).format(
              `YYYY-MM-DD${timeIncluded === true ? ' HH:mm:ss' : ''}`,
            )
          : null
      },
      toCents: (v?: number) => Math.round((v || 0) * 100),
      fromCents: (v?: number) => Math.round(v || 0) / 100,
      currency: (v?: string | number, currency?: string, lang?: string) => {
        const minimumFractionDigits = currency === 'COP' ? 0 : 2
        return `${(+(v || '')).toLocaleString(lang || 'pl-Pl', {
          style: 'currency',
          currency: currency || 'PLN',
          minimumFractionDigits,
        })}`
      },
    },
  }
})
